// INIT:
const THREE = require("three");
const UTILS = require(/*! ../libs/utils.js */"./utils.js");
const SEGMENTS = 32;
var DOME_TEXTURE;
var DOME_MATERIAL;
const GRADIENT_REVERSE = true;
const GRADIENT_AXIS = 'y';
const COLORS = [{
  stp: 0,
  col: null
}, {
  stp: .5,
  col: null
}, {
  stp: 1,
  col: null
}];
const SHRINK_AMOUNT = 2.5;
const DOME_HEIGHT = 1000;
class Zone extends THREE.Object3D {
  static fromConfig(config, RENDER) {
    return new Zone(config.zoneSize, config.zoneSpeed, config.zoneCol0, config.zoneCol1, config.zoneCol2, RENDER);
  }

  // INIT:
  constructor(_size, speed, col0, col1, col2, RENDER) {
    super();

    // SETUP:
    this._size = _size || 50;
    this._shrink = SHRINK_AMOUNT * (speed || 1);

    // SETUP MESH AND TEXTURE:
    if (RENDER) {
      if (!DOME_TEXTURE) {
        DOME_TEXTURE = new THREE.TextureLoader().load(UTILS.versionifyUrl("/textures/zone_0.png"), texture => {
          texture.wrapS = THREE.RepeatWrapping;
          texture.wrapT = THREE.RepeatWrapping;
          texture.minFilter = THREE.NearestFilter;
          texture.magFilter = THREE.NearestFilter;
          texture.repeat.set(20, 20);
          texture.needsUpdate = true;
        });
      }
      if (!DOME_MATERIAL) {
        DOME_MATERIAL = new THREE.MeshBasicMaterial({
          color: 0xffffff,
          depthWrite: false,
          flatShading: false,
          map: DOME_TEXTURE,
          vertexColors: THREE.VertexColors,
          side: THREE.DoubleSide,
          transparent: true,
          opacity: 0.5
        });
      }

      // COLORS:
      COLORS[0].col = new THREE.Color(col0 || '#3FB1B7');
      COLORS[1].col = new THREE.Color(col1 || '#6FE1CD');
      COLORS[2].col = new THREE.Color(col2 || '#FFFFFF');

      // CREATE GEO:
      let baseGeo = new THREE.SphereGeometry(1, SEGMENTS, SEGMENTS);
      baseGeo.computeBoundingBox();
      let bbox = baseGeo.boundingBox;
      let size = new THREE.Vector3().subVectors(bbox.max, bbox.min);
      let vertexIndices = ['a', 'b', 'c'];
      let face;
      let normalized = new THREE.Vector3();
      let normalizedAxis = 0;
      for (let c = 0; c < COLORS.length - 1; c++) {
        let colorDiff = COLORS[c + 1].stp - COLORS[c].stp;
        for (let i = 0; i < baseGeo.faces.length; i++) {
          let face = baseGeo.faces[i];
          for (var v = 0; v < 3; v++) {
            normalizedAxis = normalized.subVectors(baseGeo.vertices[face[vertexIndices[v]]], bbox.min).divide(size)[GRADIENT_AXIS];
            if (GRADIENT_REVERSE) {
              normalizedAxis = 1 - normalizedAxis;
            }
            if (normalizedAxis >= COLORS[c].stp && normalizedAxis <= COLORS[c + 1].stp) {
              face.vertexColors[v] = COLORS[c].col.clone().lerp(COLORS[c + 1].col, (normalizedAxis - COLORS[c].stp) / colorDiff);
            }
          }
        }
      }

      // COMPUTE NORMALS:
      baseGeo.computeVertexNormals(true);
      baseGeo.computeFaceNormals();

      // ADD MESH:
      this.baseMesh = new THREE.Mesh(baseGeo, DOME_MATERIAL);
    }

    // FINALIZE AND ADD:
    this.reset();
    if (RENDER) {
      this.add(this.baseMesh);
    }
  }

  // UPDATE SIZE:
  shrink() {
    if (this.scale.x <= 0) {
      this.visible = false;
    } else {
      this.scale.x -= this._shrink;
      this.scale.z -= this._shrink;
    }
  }

  // CLIENT ANIMATION:
  animate(delta) {
    if (this.baseMesh && this.baseMesh.material.map) {
      this.baseMesh.material.map.offset.y += 0.00003 * delta;
    }
  }

  // UPDATE DOME:
  update(size) {
    this.scale.set(size.x, DOME_HEIGHT, size.z);
    if (this.scale.x <= 0) {
      this.visible = false;
    }
  }

  // RESET EVERYTHING:
  reset() {
    this.scale.set(this._size, DOME_HEIGHT, this._size);
    this.visible = true;
  }

  // CHECK PLAYER COLLISION:
  isOutside(player) {
    return UTILS.getDistance(player.x, player.z, this.position.x, this.position.z) > this.scale.x;
  }
}
module.exports = Zone;